import EventTargetAudienceLegend from "./EventTargetAudienceLegend"

export default EventTargetAudienceLegend
